function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useMemo } from "react";
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(theme, param) {
    var readingDirection = param.readingDirection;
    var backgroundColor = theme.backgroundColor, font = theme.font, size = theme.size, spacing = theme.spacing;
    return {
        flyoutContainer: {
            base: {
                display: 'inline-block'
            }
        },
        triggerWrapper: {
            base: {
                cursor: 'pointer'
            }
        },
        popper: {
            base: _objectSpread({
                backgroundColor: backgroundColor.base,
                borderRadius: size.border.radius.fiveX,
                color: font.color.base,
                fontFamily: font.base.family,
                fontSize: font.base.size.xxs,
                fontWeight: font.base.weight.regular,
                padding: 0
            }, readingDirection)
        },
        caretFlyoutWrapper: {
            base: {
                padding: spacing[5]
            }
        },
        largeCaretFlyoutWrapper: {
            base: {
                padding: spacing[6]
            }
        }
    };
};
var useStyle = function(largeCaret, noPadding, isRtl) {
    var ref;
    var ref1 = (ref = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref !== void 0 ? ref : {}, triggerWrapper = ref1.triggerWrapper, flyoutContainer = ref1.flyoutContainer, caretFlyoutWrapper = ref1.caretFlyoutWrapper, largeCaretFlyoutWrapper = ref1.largeCaretFlyoutWrapper, popper = ref1.popper;
    return useMemo(function() {
        return {
            triggerWrapperStyles: _objectSpread({}, triggerWrapper === null || triggerWrapper === void 0 ? void 0 : triggerWrapper.base),
            flyoutContainerStyles: _objectSpread({}, flyoutContainer === null || flyoutContainer === void 0 ? void 0 : flyoutContainer.base),
            popperStyles: _objectSpread({}, popper === null || popper === void 0 ? void 0 : popper.base, !noPadding && (largeCaret ? largeCaretFlyoutWrapper === null || largeCaretFlyoutWrapper === void 0 ? void 0 : largeCaretFlyoutWrapper.base : caretFlyoutWrapper === null || caretFlyoutWrapper === void 0 ? void 0 : caretFlyoutWrapper.base))
        };
    }, [
        largeCaret,
        noPadding,
        triggerWrapper,
        flyoutContainer,
        popper,
        caretFlyoutWrapper,
        largeCaretFlyoutWrapper
    ]);
};
export default useStyle;
